import { Suspense } from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import AppWrapper from "./AppWrapper";
import "./i18n";
import reportWebVitals from "./reportWebVitals";

const root = document.getElementById("root");

const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

if (isInIframe()) {
  root.innerHTML = `
    <div style="padding: 20px; color: red;">
      <h1>Acceso no autorizado</h1>
    </div>
  `;
} else {
  ReactDOM.render(
    <HashRouter>
      <Suspense fallback="">
        <AppWrapper></AppWrapper>
      </Suspense>
    </HashRouter>,
    root
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
